/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { MutationRequestStatus, RootState } from '../types';
import { CloudResponse, CloudState } from './types';

export const getters: GetterTree<CloudState, RootState> = {
  success: (state) => state.clouds.status === MutationRequestStatus.SUCCESS,
  error: (state) => state.clouds.status === MutationRequestStatus.ERROR,
  loading: (state) => state.clouds.status === MutationRequestStatus.LOADING,

  clouds(state): CloudResponse {
    return state.clouds.data;
  },

  renewSuccess: (state) => state.renew.status === MutationRequestStatus.SUCCESS,
  renewError: (state) => state.renew.status === MutationRequestStatus.ERROR,
  renewLoading: (state) => state.renew.status === MutationRequestStatus.LOADING,
};
